import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../pages/login/UserContextPersistent";
import {
  installAxiosAuthInterceptor,
  uninstallAxiosAuthInterceptor,
} from "./axiosAuthInterceptor";

export default function AxiosAuthBootstrap() {
  const navigate = useNavigate();
  const { dispatch } = useUser();
  const dispatchRef = useRef(dispatch);
  const navigateRef = useRef(navigate);

  dispatchRef.current = dispatch;
  navigateRef.current = navigate;

  useEffect(() => {
    installAxiosAuthInterceptor(
      () => dispatchRef.current,
      () => navigateRef.current,
    );
    return () => uninstallAxiosAuthInterceptor();
  }, []);

  return null;
}
